/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useMutation } from '@apollo/client';
import { handleApolloError } from '@exo/frontend-common-apollo';

export const SAVE_SERVICE = gql`
  mutation SaveService($serviceId: ID!, $favouriteServiceName: String!, $serviceLevel: String!) {
    saveFavouriteService(serviceId: $serviceId, favouriteServiceName: $favouriteServiceName, serviceLevel: $serviceLevel) 
  }
`;

export const useSaveService = () => {
    const [saveService, { data, loading, error }] = useMutation(SAVE_SERVICE, {
        onError(err) {
            if (process.env.NODE_ENV === 'development' || process.env.JEST_WORKER_ID !== undefined) {
                // eslint-disable-next-line no-console
                console.error(`Error ${__filename}: ${JSON.stringify(err, undefined, '  ')}`);
            }
            return err;
        }
    });

    handleApolloError(__filename, error);
    return {
        saveService: async (serviceId, favouriteServiceName, serviceLevel) => {
            return saveService({
                variables: { serviceId, favouriteServiceName, serviceLevel }
            });
        },
        data,
        loading,
        error
    };
};


